import type { ReactNode } from 'react';
import { Suspense, useState } from 'react';

import { CancelSalePopin } from '#src/components/offer/CancelSalePopin/index.tsx';

import type { SingleSaleOfferPopinInfo } from './index.tsx';
import { SingleSaleOfferContext } from './index.tsx';

type Props = {
  children: ReactNode;
};

export const SingleSaleOfferProvider = ({ children }: Props) => {
  const [popinInfo, setPopinInfo] = useState<SingleSaleOfferPopinInfo | null>(
    null
  );

  return (
    <SingleSaleOfferContext.Provider
      value={{
        showPopin: setPopinInfo,
      }}
    >
      {!!popinInfo && (
        <Suspense fallback={null}>
          <CancelSalePopin
            slug={popinInfo.slug}
            onClose={() => setPopinInfo(null)}
          />
        </Suspense>
      )}
      {children}
    </SingleSaleOfferContext.Provider>
  );
};
